export enum TestFeatureFlags {
    TestFeatureOne = 'TestFeatureOne',
    TestFeatureTwo = 'TestFeatureTwo'
}
